import React from 'react'
import { BRANDS } from '../../utils/brand'
import { getAppType } from '../../utils/appType'
import './Loader.scss'

type Props = {
  fullscreen?: boolean
  size?: number
}

const c = 'panda-loader'

const Loader = ({ fullscreen, size = 64 }: Props) => (
  <div
    className={`${c}${fullscreen ? ` ${c}--fullscreen` : ''}`}
    role='status'
    aria-label='loading'
  >
    <div className={`${c}__bounce`} style={{ width: size, height: size }}>
      <img src={BRANDS[getAppType()].mascot} alt='' draggable={false} />
    </div>
    <div className={`${c}__shadow`} style={{ width: size * 0.7 }} />
    <div className={`${c}__dots`}>
      <span />
      <span />
      <span />
    </div>
  </div>
)

export default Loader
